import React, {Component} from "react"
import axios from "axios";
import {addRemoveDoctorToList, getHeader} from "../../config";
import {setDoctorProfileCardSkeleton} from "../../skeleton";
import SweetAlert from 'react-bootstrap-sweetalert';
import ProgressiveImage from "react-progressive-image-loading";
import Rating from "react-rating";
import SubSpecialtyCard from "./SubSpecialtyCard";
import {withTranslate} from "react-redux-multilingual";
import {
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';

import {
    FacebookIcon,
    TwitterIcon,
    WhatsappIcon,
    LinkedinIcon,
} from 'react-share';

class DoctorProfileCard extends Component {

    state = {
        showErrorSweetAlert: false,
        showLoginSweetAlert: false,
        type: 0,
        numOfSubSpecialty: 5,
        account_id: null,
        copied: false,
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            account_id: nextProps.doctor ? nextProps.doctor.account_id : null,
            type: nextProps.doctor ? nextProps.doctor.is_favourite : 0,
        });
    }

  /*  showTitle = (doctor) => {
        let copyDoctorTitle = document.getElementById("copy-doctor-title" + doctor.id);
        copyDoctorTitle.style.display = "block";
    };
    hideTitle = (doctor) => {
        let copyDoctorTitle = document.getElementById("copy-doctor-title" + doctor.id);
        copyDoctorTitle.style.display = "none";
    };
    copiedLink = () => {
        this.setState({copied: true});
        showToast(this.props.translate('doctor_profile_link_copied_successfully'), "green")
    };*/
    confirmLogin = () => {
        window.location.href = "login";
    };
    toggleFavouriteDoctor = (e, type) => {
        e.preventDefault();
        if (!this.props.authUser) {
            this.setState({
                showLoginSweetAlert: true,
            });
        } else {
            this.setState({
                type: type,
            });
            axios.post(addRemoveDoctorToList, this.state, {headers: getHeader()}).then(res => {
                if (res.data.Error.code !== 20) {
                    this.setState({
                        showErrorSweetAlert: true,
                        type: 0,
                    });
                }
            }).catch(error => {
                console.log(error);
            })
        }

    };
    toggleShowMore = (e, num, stateVariable, collapsePropsLength) => {
        e.preventDefault();
        console.log(num, collapsePropsLength)
        switch (stateVariable) {
            case "numOfSubSpecialty" :
                this.setState({
                    numOfSubSpecialty: this.state.numOfSubSpecialty === num ? collapsePropsLength : num,
                });
                break;
            default:
        }
    };

    render() {
        const {doctor, currentDoctorIsLoading, translate} = this.props;
        const subSpecialties = doctor && doctor.sub_specialities.length ? doctor.sub_specialities.slice(0, this.state.numOfSubSpecialty).map((subSpecialty, index) => {
            return (
                <span key={index}>
                       <SubSpecialtyCard subSpecialty={subSpecialty}/>
                    </span>
            )
        }) : null;
        return (
            <div className="about-author flex-item" id="about-doctor">
                {!currentDoctorIsLoading ? (
                        <div className="no-padding">
                            <div className="doctor-main-info shadow-4d">
                                <div className="doctor-profile-area">
                                    <div className="ad-fav-box">
                                        <div className="doctor-options">
                                            <i onClick={(e) => this.toggleFavouriteDoctor(e, 1)}
                                               className="far fa-heart font-25 dark-blue cursor-pointer"
                                               hidden={this.state.type}></i>
                                            <i onClick={(e) => this.toggleFavouriteDoctor(e, 0)}
                                               className="fas fa-heart font-25 dark-blue cursor-pointer"
                                               hidden={!this.state.type}></i>

                                         {/*   <div onMouseOver={() => this.showTitle(doctor)}
                                                 onMouseOut={() => this.hideTitle(doctor)}>
                                                <div className="copy-doctor-icon">
                                                    <i className="fas fa-share-alt font-25 dark-blue cursor-pointer"></i>
                                                    <p className="copy-doctor-title"
                                                       id={"copy-doctor-title" + doctor.id}>{this.props.translate('copy_doctor_profile_link')}</p>
                                                </div>
                                            </div>*/}
                                            <span hidden={doctor.sponsored === 0}
                                                  className="doctor-sponsored bolder">{translate('sponsored')}</span>
                                        </div>


                                        {/********************Login***************/}
                                        <SweetAlert
                                            show={this.state.showLoginSweetAlert}
                                            title={translate("login")}
                                            showCancel
                                            warning
                                            cancelBtnBsStyle="sweet custom-danger"
                                            confirmBtnBsStyle="sweet success-sweet"
                                            onCancel={() => this.setState({showLoginSweetAlert: false})}
                                            onConfirm={() => this.confirmLogin()}
                                            confirmBtnText={translate("login")}>
                                            {translate("please_login")}
                                        </SweetAlert>
                                        {/********************Error***************/}
                                        <SweetAlert
                                            warning
                                            confirmBtnBsStyle="sweet success-sweet"
                                            show={this.state.showErrorSweetAlert}
                                            title={translate("error")}
                                            onConfirm={() => this.setState({showErrorSweetAlert: false})}
                                            confirmRequestPlanBtnText={translate("ok")}>
                                            {translate("something_wrong")}
                                        </SweetAlert>

                                        <div className="width-percentage-25 doctor-premium-btn">
                                            <a className="relative"
                                               href="/premium">{translate("premium")}</a>
                                        </div>
                                    </div>
                                    <div className="doctor-profile-image-wrapper-box">
                                        <div className="doctor-profile-image">
                                            <div className="avatar align-self-md-center">
                                                <ProgressiveImage
                                                    preview="/images/doctor-image-placeholder.png"
                                                    src={doctor.image}
                                                    render={(src, style) => <img className="full-width"
                                                                                 alt="head" src={src}
                                                                                 style={style}/>}
                                                />
                                                {
                                                    doctor.account_type ?
                                                        <a href={"/doctor/" + doctor.hospital.unique_id + "/hospital"}>
                                                            <div className="hospital-area">
                                                                <ProgressiveImage
                                                                    preview="/images/doctor-image-placeholder.png"
                                                                    src={doctor.image}
                                                                    render={(src, style) => <img alt={doctor.account_name} src={src}
                                                                                                 style={style}/>}
                                                                />
                                                                <p className="trimmed-p">{doctor.account_name}</p>
                                                            </div>
                                                        </a> : null
                                                }
                                            </div>
                                            <span hidden={doctor.is_premium === 0}><img alt="premium"
                                                                                        src="../../images/premium.png"/></span>
                                        </div>
                                    </div>

                                </div>
                                <br/>
                                <div className="desc text-center align-self-md-center capitalized">
                                    <h4 className="doctor-name text-center font-25">{doctor.account_type === 1 ? doctor.doctor_name : doctor.account_name}</h4>
                                    {/*<p className="mb-0 black text-center bolder font-20">{doctor.speciality !== null ? doctor.speciality : null}</p>*/}
                                    <p className="mb-0 text-center">{doctor.title !== null ? doctor.title : null}</p>

                                    <p className="doctor-followers">{translate("recommended_by") + " "}
                                        <span
                                            className="bolder app-color">{doctor.my_recommends_count}</span> {" " + translate("user")}
                                    </p>
                                    {/*<p className="doctor-views shadow-4d">{doctor.views !== null ? doctor.views + " " + translate("views") : null}</p>*/}
                                    <Rating
                                        direction={this.props.language === 'ar' ? "rtl" : "ltr"}
                                        initialRating={doctor.rate}
                                        readonly
                                        emptySymbol="fa fa-star-o font-20 empty-star"
                                        fullSymbol="fa fa-star font-20 full-star"
                                    />

                                    <p className="doctor-reviews text-center cursor-pointer"
                                       onClick={(e) => this.props.handleScrollToReviews(e)}>
                                        {doctor.reviews + " " + translate('reviews')}
                                    </p>

                                    <div className="text-center tags">
                                        {/*<strong>{translate("doctor")}</strong>*/}
                                        {subSpecialties}
                                        {doctor && doctor.sub_specialities && doctor.sub_specialities.length ?
                                            <p className="cursor-pointer bolder dark-blue"
                                               hidden={doctor.sub_specialities.length < this.state.numOfSubSpecialty || doctor.sub_specialities.length === 5}
                                               onClick={(e) => this.toggleShowMore(e, 5, "numOfSubSpecialty", doctor.sub_specialities.length)}>
                                                {this.state.numOfSubSpecialty === 5 ?
                                                    "+ "
                                                    + (doctor.sub_specialities.length - this.state.numOfSubSpecialty)
                                                    + ' '
                                                    + translate('show_more') :
                                                    translate('show_less')} </p>
                                            : null}
                                    </div>
                                    <div className="share-area text-center">
                                        <FacebookShareButton
                                            url={window.location.origin + "/doctor/" + doctor.unique_id}>
                                            <FacebookIcon size={32} round/>
                                        </FacebookShareButton>
                                        <LinkedinShareButton
                                            url={window.location.origin + "/doctor/" + doctor.unique_id}>
                                            <LinkedinIcon size={32} round/>
                                        </LinkedinShareButton>
                                        <TwitterShareButton
                                            url={window.location.origin + "/doctor/" + doctor.unique_id}>
                                            <TwitterIcon size={32} round/>
                                        </TwitterShareButton>
                                        <WhatsappShareButton
                                            url={window.location.origin + "/doctor/" + doctor.unique_id}>
                                            <WhatsappIcon size={32} round/>
                                        </WhatsappShareButton>
                                    </div>
                                </div>
                            </div>
                        </div>)
                    : setDoctorProfileCardSkeleton()}
            </div>
        )
    }
}

export default withTranslate(DoctorProfileCard)